<!--#region emoji  -->
<div #container>
  <button
    (click)="toggled()"
    [matTooltip]="'common.emoji' | translate"
    matTooltipPosition="left"
    class="tw-flex tw-mx-1 tw-justify-center tw-h-full tw-w-12 tw-text-gray-400 hover:tw-text-gray-600 dark:hover:tw-text-gray-300"
    [ngClass]="{
      'tw-items-end tw-pb-2': isHeightChange,
      'tw-items-center': !isHeightChange
    }"
  >
    <!-- icon -->
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 24 24"
      fill="#ffdc68"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#b76d40"
        d="M8.83216 14.4453C8.5258 13.9858 7.90493 13.8616 7.44541 14.168C6.98588 14.4743 6.8617 15.0952 7.16806 15.5547C9.46675 19.0028 14.5335 19.0028 16.8322 15.5547C17.1385 15.0952 17.0143 14.4743 16.5548 14.168C16.0953 13.8616 15.4744 13.9858 15.1681 14.4453C13.661 16.7059 10.3392 16.7059 8.83216 14.4453ZM17.0001 9.5C17.0001 10.3284 16.3285 11 15.5001 11C14.6717 11 14.0001 10.3284 14.0001 9.5C14.0001 8.67157 14.6717 8 15.5001 8C16.3285 8 17.0001 8.67157 17.0001 9.5ZM10.0001 9.5C10.0001 10.3284 9.32853 11 8.50011 11C7.67168 11 7.00011 10.3284 7.00011 9.5C7.00011 8.67157 7.67168 8 8.50011 8C9.32853 8 10.0001 8.67157 10.0001 9.5Z"
      />
    </svg>
  </button>

  <emoji-mart
    class="emoji-mart tw-absolute tw-bottom-[20px] tw-z-[1000]"
    *ngIf="isEmojiPickerVisible"
    emoji="point_up"
    [emojisToShowFilter]="emojisToShowFilter"
    (emojiSelect)="emitEmoji($event)"
    [showPreview]="false"
    [enableSearch]="false"
    [darkMode]="appStateService.currentThemeMode() == 'dark'"
    [isNative]="true"
    [autoFocus]="false"
    [emojiTooltip]="false"
    title=""
    [showSingleCategory]="true"
    [ngClass]="appStateService.isLtr() ? 'tw-right-[-20px]' : 'tw-left-[-20px]'"
    title="Choose your emoji"
  ></emoji-mart>
</div>
<!--#endregion  -->
